import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeContextProvider } from './ThemeContext';
import { ChatbotProvider } from './contexts/ChatbotContext'; // Import the provider
import { DocumentUploadProvider } from './contexts/DocumentUploadContext';
import { WebsiteScrapeProvider } from './contexts/WebsiteScrapeContext';
import { BrowserRouter} from "react-router-dom";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeContextProvider>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ChatbotProvider> {/* Wrap the App */}
          <DocumentUploadProvider>
            <WebsiteScrapeProvider>
              <App />
            </WebsiteScrapeProvider>
          </DocumentUploadProvider>
        </ChatbotProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </ThemeContextProvider>
);